/* import __COLOCATED_TEMPLATE__ from './cmrr-offset.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();